export const environment = {
    production: false,
    baseUrl: 'https://closedcaptions.ai/',
    appName: 'Subscription Module for Morlogix',
    encryptionKey: 'sdfsfdUnj5n8xdj9IEBasdfsdfvFsdf_#@#JRrc',
    firebase: {
        apiKey: 'AIzaSyDts04p2j0GShVy3Dyq6t7n3PAY5qFiBYs',
        authDomain: 'closedcaptions-ai.firebaseapp.com',
        projectId: 'closedcaptions-ai',
        storageBucket: 'closedcaptions-ai.appspot.com',
        messagingSenderId: '151508545035',
        appId: '1:151508545035:web:0082da0e7431795feda10e',
        measurementId: 'G-PH72FD4T0W',
    },

    firebaseCloudfunction: {
        allS3Bucket:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/allS3Bucket',
        createS3Bucket:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/createS3Bucket',
        createS3object:
            'http://localhost:5000/closedcaptions-ai/us-central1/UpdateFile',
        onlyS3Bucket:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/OnlyS3Bucket',
        downloadFileFromURL:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/downloadFileFromUrl',
        createOneTimePayment:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/createOneTimePayment',
        createCustomer:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/createCustomer',
        retrievePaymentMethods:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/retrievePaymentMethods',
        attachPaymentMethodId:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/attachPaymentMethodId',
        deletePaymentMethond:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/deletePaymentMethod',
        getGCP: 'https://us-central1-closedcaptions-ai.cloudfunctions.net/getgcpdata',
        getBlobdata:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/getGCPBlobData',
        sendEmail:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/sendEmailBySES',
        uploadGCPtoS3:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadGCPtoS3',
        getawstime:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/gettimeaws',
        uploadAWStoAWS:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadAwstoAws',
        processVideoImageDetection:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/processVideoImageDetection',
        videoDuration:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/videoDuration',
        refundMoney:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/refundMoney',
        openAi: 'https://us-central1-closedcaptions-ai.cloudfunctions.net/openAiModel',
        checkPasswordHistory:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/checkPasswordHistory',

        translateText:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/translateText',
        translateObject:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/translateObject',
        getSignedUrlFunction:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/getSignedUrlFunction',
        s3UploadVideos:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/s3UploadVideos',
        uploadFileToS3Function:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadFileToS3Function',
        uploadCompanyProfileFunction:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadCompanyProfileFunction',
        uploadFileFunction:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadFileFunction',
        getMultipleFilesUrls:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/getMultipleFilesUrls',
        uploadLinkToS3:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadLinkToS3',

        putObjectFunction:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/putObjectFunction',
        getObjectFunction:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/getObjectFunction',
        getJsonObjectFunction:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/getJsonObjectFunction',
        putJsonObjectFunction:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/putJsonObjectFunction',
    },
    devFirebaseCloudfunction: {
        allS3Bucket:
            //"http://localhost:5000/closedcaptions-ai/us-central1/allS3Bucket",

            'https://us-central1-closedcaptions-ai.cloudfunctions.net/allS3Bucket',
        createS3Bucket:
            'http://localhost:5000/closedcaptions-ai/us-central1/createS3Bucket',
        createS3object:
            'http://localhost:5000/closedcaptions-ai/us-central1/UpdateFile',
        onlyS3Bucket:
            'http://localhost:5000/closedcaptions-ai/us-central1/OnlyS3Bucke',
        downloadFileFromURL:
            'http://localhost:5000/closedcaptions-ai/us-central1/downloadFileFromUrl',
        createOneTimePayment:
            'http://localhost:5000/closedcaptions-ai/us-central1/createOneTimePayment',
        createCustomer:
            'http://localhost:5000/closedcaptions-ai/us-central1/createCustomer',
        retrievePaymentMethods:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/retrievePaymentMethods',
        attachPaymentMethodId:
            'http://localhost:5000/closedcaptions-ai/us-central1/attachPaymentMethodId',
        deletePaymentMethond:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/deletePaymentMethod',
        getGCP: 'http://localhost:5000/closedcaptions-ai/us-central1/getgcpdata',
        getBlobdata:
            'http://localhost:5000/closedcaptions-ai/us-central1/getGCPBlobData',
        sendEmail:
            'http://localhost:5000/closedcaptions-ai/us-central1/sendEmailBySES',
        uploadGCPtoS3:
            'http://localhost:5000/closedcaptions-ai/us-central1/uploadGCPtoS3',
        getawstime:
            'http://localhost:5000/closedcaptions-ai/us-central1/gettimeaws',
        uploadAWStoAWS:
            'http://localhost:5000/closedcaptions-ai/us-central1/uploadAwstoAws',
        processVideoImageDetection:
            'http://localhost:5000/closedcaptions-ai/us-central1/processVideoImageDetection',
        uploadChunksFile:
            'http://localhost:5000/closedcaptions-ai/us-central1/uploadChunksFile',
        splitVideoFile:
            'http://localhost:5000/closedcaptions-ai/us-central1/splitVideoFile',
        videoDuration:
            'http://localhost:5000/closedcaptions-ai/us-central1/videoDuration',
        refundMoney:
            'http://localhost:5000/closedcaptions-ai/us-central1/refundMoney',
        openAi: 'http://localhost:5000/closedcaptions-ai/us-central1/openAiModel',
    },
    //firebaseCloudfunction: {
    //  allS3Bucket:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/allS3Bucket",
    //  createS3Bucket:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/createS3Bucket",
    //  createS3object:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/UpdateFile",
    //  onlyS3Bucket:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/OnlyS3Bucket",
    //  downloadFileFromURL:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/downloadFileFromUrl",
    //  createOneTimePayment:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/createOneTimePayment",
    //  createCustomer:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/createCustomer",
    //  retrievePaymentMethods:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/retrievePaymentMethods",
    //  attachPaymentMethodId:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/attachPaymentMethodId",
    //  deletePaymentMethond:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/deletePaymentMethod",
    //  getGCP:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/getgcpdata",
    //  getBlobdata:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/getGCPBlobData",
    //  sendEmail:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/sendEmailBySES",
    //  uploadGCPtoS3:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadGCPtoS3",
    //  getawstime:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/gettimeaws",
    //  uploadAWStoAWS:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/uploadAwstoAws",
    //  processVideoImageDetection:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/processVideoImageDetection",
    //  videoDuration:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/videoDuration",
    //  refundMoney:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/refundMoney",
    //  openAi:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/openAiModel",
    //  checkPasswordHistory: 'https://us-central1-closedcaptions-ai.cloudfunctions.net/checkPasswordHistory'
    //},
    //devFirebaseCloudfunction: {
    //  allS3Bucket:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/allS3Bucket",
    //  createS3Bucket:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/createS3Bucket",
    //  createS3object:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/UpdateFile",
    //  onlyS3Bucket:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/OnlyS3Bucke",
    //  downloadFileFromURL:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/downloadFileFromUrl",
    //  createOneTimePayment:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/createOneTimePayment",
    //  createCustomer:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/createCustomer",
    //  retrievePaymentMethods:
    //    "https://us-central1-closedcaptions-ai.cloudfunctions.net/retrievePaymentMethods",
    //  attachPaymentMethodId:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/attachPaymentMethodId",
    //  getGCP: "http://localhost:5000/closedcaptions-ai/us-central1/getgcpdata",
    //  getBlobdata:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/getGCPBlobData",
    //  sendEmail:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/sendEmailBySES",
    //  uploadGCPtoS3:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/uploadGCPtoS3",
    //  getawstime:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/gettimeaws",
    //  uploadAWStoAWS:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/uploadAwstoAws",
    //  processVideoImageDetection:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/processVideoImageDetection",
    //  uploadChunksFile:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/uploadChunksFile",
    //  splitVideoFile:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/splitVideoFile",
    //  videoDuration:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/videoDuration",
    //  refundMoney:
    //    "http://localhost:5000/closedcaptions-ai/us-central1/refundMoney",
    //  openAi: "http://localhost:5000/closedcaptions-ai/us-central1/openAiModel",
    //},

    lambdaFunction: {
        extractAudio:
            'https://qg4w2ezbgb.execute-api.us-east-1.amazonaws.com/development/extract-audio',
        uploadChunks:
            'https://7v1s53ibj0.execute-api.us-east-1.amazonaws.com/Development/chunks-upload',
    },
    stripe: {
        publicKey:
            'pk_test_51OeGdZHfBkeJOnHOWDtrh2gC5LgxGHRcYZrr5gVZpAy4YSo3OSsH0UY1KXnqQjXYjpiXQ8fNIQXFeQd2Wn1IGQoZ00j0LbBZ5B',
        // publicKey:
        //   "pk_live_51OeGdZHfBkeJOnHOSZXNhP0byYEL1xGYYs3a2kW7C9J0U38DRguGeGOL5EwsU8I4gu2sxmNjMrJoaHJidQAAsjEH00PFMUPFwL",

        createOneTimePayment:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/createOneTimePayment',
        createCustomer:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/createCustomer',
        retrievePaymentMethods:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/retrievePaymentMethods',
        createS3Bucket:
            'https://us-central1-closedcaptions-ai.cloudfunctions.net/createS3Bucket',
        createSubscriptionDialerService:
            'http://localhost:5000/morlogix-new/us-central1/createSubscriptionDialerService',
    },
    backendApiUrl: 'https://api.phonetik.ai', // FastAPI backend URL
};
